module.exports = "../fonts/hotel_pets_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_pets_icon.svg
// module id = 445
// module chunks = 0